import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'

import media from 'styles/media'

type Props = {
  children?: JSX.Element|JSX.Element[];
  background: string,
  toRight?: boolean,
  loaded: boolean
}

const Banner: React.FC<Props> = ({ children, background, toRight, loaded }) => {

  const [innerRef, setInnerRef] = useState<HTMLDivElement | null>(null)
  const [translate, setTranslate] = useState<number>(0)

  useEffect(() => {
    if (innerRef && loaded) {
      const innerRect = innerRef.getBoundingClientRect()
      const width = innerRect.width
      const translate = width / 2
  
      setTranslate(translate)
    }
  }, [innerRef, loaded])

  return (
    <Wrapper background={background}>
      <Inner ref={(ref: any) => setInnerRef(ref)} $translate={translate} toRight={toRight}>
        {children}
        {children}
        {children}
        {children}
        {children}
        {children}
        {children}
        {children}
      </Inner>
    </Wrapper>
  )
}

export default Banner

const Wrapper = styled.div<{background: string}>`
  background: ${props => props.background};
  position: relative;
  width: 100%;
  overflow: hidden;

  height: 3.4vw;

  ${media.tablet} {
    height: 5.566vw;
  }
  ${media.mobile} {
    height: 7.733vw;
  }
`

const marqueeEffect = (x: number) => keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-${x}px);
  }
`

const marqueeEffectRight = (x: number) => keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(${x}px);
  }
`

const Inner = styled.div<{$translate: number, toRight?: boolean}>`
  position: relative;
  top: 0;
  left: ${props => props.toRight ? '-50%' : '0%'};
  display: flex;
  align-items: center;
  width: fit-content;
  white-space: pre;
  animation: ${props => {
    if (props.toRight) {
      return marqueeEffectRight(props.$translate)
    } else {
      return marqueeEffect(props.$translate)
    }
  }} 15s linear infinite;
`